import { VoucherOrder } from '@epi-models/pages/PaperVouchers';

import { QueryParameters } from '../reducers/api/transactionsHistory';

export const getOrderHistoryQueryPage = (state): number =>
  state.orderHistory.queryParameters.page;

export const getOrderHistoryQueryRowsPerPage = (state): number =>
  state.orderHistory.queryParameters.rowsPerPage;

export const getOrderHistoryQuerySortingBy = (state): string =>
  state.orderHistory.queryParameters.sortingBy;

export const getOrderHistoryQueryDescending = (state): boolean =>
  state.orderHistory.queryParameters.descending;

export const getOrderHistoryQuery = (state): QueryParameters =>
  state.orderHistory.queryParameters;

export const getVoucherOrderHistory = (state): VoucherOrder[] =>
  state.apiVoucherOrdersHistory.voucherOrders;

export const getVoucherOrderHistoryTotalPages = (state): number =>
  state.apiVoucherOrdersHistory.totalPages;
